// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { HomeTrendUp, People, ShieldSecurity } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  developmentCompany: HomeTrendUp,
  people: People,
  special: ShieldSecurity
};

// ==============================|| MENU ITEMS - DEVELOPMENT COMPANY ||============================== //

const developmentCompany: NavItemType = {
  id: 'development-company-group',
  title: <FormattedMessage id="common.menu.developmentCompanies.group" />,
  type: 'group',
  children: [
    {
      id: 'developmentCompany',
      title: <FormattedMessage id="common.menu.developmentCompanies.developmentCompanies" />,
      type: 'item',
      url: '/development-companies',
      icon: icons.developmentCompany
    },
    {
      id: 'developmentCompanySpecial',
      title: <FormattedMessage id="specDevCompanies.common.title" />,
      url: '/development-companies/special',
      type: 'item',
      icon: icons.special
    }
  ]
};

export default developmentCompany;
